<la-dialog-header>{{ data.title }}</la-dialog-header>

<la-dialog-content>
  <p>{{ data.message }}</p>
</la-dialog-content>

<la-dialog-footer>
  <ng-container la-dialog-footer-right>
    @if (data.cancelText) {
      <la-button appearance="basic" matDialogClose>{{ data.cancelText }}</la-button>
    }
    <la-button appearance="primary" (action)="onConfirm()">{{ data.confirmText || 'OK' }}</la-button>
  </ng-container>
</la-dialog-footer>
